export const OFFERS_SEARCH_STYLES = {
  root: "w-full min-w-0",
  title:
    "text-[28px] md:text-[24px] font-bold text-ticketon-lighter-blue break-words",
  card: "mt-4 grid min-w-0 grid-cols-1 gap-4 rounded-[16px] bg-white p-2 shadow-ticketon-card md:grid-cols-[280px_1fr] md:items-start md:p-6",
  cardNoImage: "mt-4 min-w-0",
  imageWrapper:
    "relative hidden shrink-0 overflow-hidden rounded-[12px] md:mt-4 md:block md:h-[300px] md:w-[280px]",
  image: "h-[300px] w-[280px] max-w-full object-cover",
  form: "flex min-w-0 flex-col gap-4",
  mobileTabsRow:
    "flex w-full min-w-0 items-center justify-between overflow-hidden md:hidden",
  inputWrapper:
    "relative flex h-12 items-center rounded-[16px] border border-ticketon-lighter-blue bg-white shadow-ticketon-card md:h-14",
  inputIcon: "pointer-events-none absolute left-3 top-1/2 -translate-y-1/2",
  input:
    "h-full w-full rounded-[16px] bg-transparent pl-10 pr-3 text-[14px] text-ticketon-dark-text placeholder:text-muted-foreground focus:outline-none",
  dateGrid: "grid grid-cols-1 gap-3 md:grid-cols-2",
  dateFieldWrapper:
    "flex h-12 cursor-pointer items-center gap-2 rounded-[16px] border border-ticketon-light-border bg-white px-3 shadow-component md:h-14",
  dateFieldIcon: "shrink-0 text-ticketon-lighter-blue",
  dateFieldContent: "flex min-w-0 flex-1 flex-col",
  dateFieldLabel:
    "text-[12px] font-medium leading-[100%] text-ticketon-dark-blue",
  dateFieldValue:
    "mt-1 text-[12px] font-normal leading-[100%] text-ticketon-dark-blue",
  dateFieldChevron: "ml-1 mr-2 shrink-0 text-ticketon-lighter-blue",
  dateInput: "sr-only",
  cta: "mt-1 inline-flex w-full items-center justify-center gap-2 rounded-[8px] bg-ticketon-blue px-6 py-3 text-[14px] font-semibold text-white transition-colors hover:bg-ticketon-lighter-blue-hover md:w-fit md:self-end",
  ctaIcon: "h-4 w-4 shrink-0",
} as const;
